<template>
    <div>
        <div class="banner swiper-container" id="home-swiper" v-loading="bannerLoading">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                    <img :src="item.ImagePath" alt="">
                </div>
            </div>

            <div class="swiper-pagination"></div>


        </div>
        <!--    关于我们    -->
        <div class="about clearfix md-about">
            <div class="about-left md-about-left">
                <h1>关于我们</h1>
                <h2>永不分梨介绍</h2>
                <p class="introduce md-introduce">
                    邯郸永不分梨酒业股份有限公司是一家由宜宾五粮液股份有限公司控股的白酒酿造生产销售企业，成立于2013年8月5日。
                    公司的生产经营，始终坚持以“传承五粮液文化、锻造永不分梨品牌”为使命，以“建设五粮液原产地之外系列酒区域基地”为目标，以“酿造美好，传递真情”为宗旨，秉承“为社会创造价值，为消费者酿造美好，为员工谋求福利，为投资者贡献回报”的核心价值观，发扬“和合守正，开拓创新，甘于奉献，追求卓越”的企业精神，推动公司快速健康发展。
                    公司成立以来，在五粮液公司和地方党委政府的领导和支持下，得到了长足发展。经过公司多年发展，已成为临漳县骨干企业和第一纳税大户、市农业产业化龙头企业、邯郸市招商引资典范企业。
                    永不分梨公司的发展，带动了当地相关产业的发展，并提供了就业岗位千余个，对当地富民强县起到了重要的推动作用。公司还积极参与和资助社会各项公益活动，特别是在支援疫情防控、抗洪救灾、扶贫济困、资助残疾人和困难大学生以及赞助临漳县旅游文化周、曹操杯诗词大赛、广场舞等群众文体活动，为邯郸市及临漳县经济和社会发展做出了应有的贡献。
                    公司先后获得“中国消费者满意名特优品牌”、“河北省著名商标”、“河北省名牌产品”、“2015年中华全国总工会模范职工小家”、“2018年度河北省安全生产文化示范单位”等荣誉称号；公司包装车间三班组获得中华全国总工会“工人先锋号”荣誉称号；公司生产的39°郸酒壹号、42°郸酒9钻、39°1385纪念酒、42°郸酒精典、40°永不分梨（晶质礼盒）、“52%vol喜福盛世”分别在2017年-2022年连续六年荣获中国国际酒业博览会“青酌奖”酒类新品TOP10。39°郸酒窖龄原浆（30）产品也荣获2021年国际传统发酵食品创新大赛“年度新品·大金奖”。公司生产的酱香型白酒通过中国酒业协会专家团严格的技术鉴定和年份认证，获得了“白酒年份酒资质认定证书”。
                </p>

                <div class="price clearfix">
                    <div class="price-item md-price-item">
                        <p class="price-title">使命</p>
                        <p class="price-content">传承五粮液文化、<br/>锻造永不分梨品牌</p>
                    </div>

                    <div class="price-item md-price-item">
                        <p class="price-title">愿景</p>
                        <p class="price-content">
                            建设五粮液原产地<br/>之外系列酒区域基地
                        </p>
                    </div>

                    <div class="price-item md-price-item" style="margin-right: 0">
                        <p class="price-title">价值观</p>
                        <p class="price-content">
                            为消费者酿造美好，为社会创造价值<br/>为员工谋求福利，为投资者贡献回报
                        </p>
                    </div>
                </div>

                <div class="understand md-understand hvr-forward" @click="goPage('/about/group')">
                    进一步了解 <img src="@/assets/img/more.png" alt=""/>
                </div>
            </div>

            <div class="about-right boling-img"><img src="@/assets/img/about.png" alt=""/></div>
        </div>

        <!--    产品中心    -->
        <div class="product clearfix md-pro">
            <div class="pro-bgk"><img src="@/assets/img/product.png" alt=""></div>

            <div class="product-left">
                <h1 >产品中心</h1>
                <h2>匠心铸就品质</h2>
                <ul class="goodtitwrap">
                    <!-- <li class="active">红酒系列</li> -->
                    <li
                        v-for="(item, index) in goodsTitList"
                        :class="goodTitSelectIndex == index ? 'active' : ''"
                        @click="changeGoods(item.ShowCategoryID,index)"
                        :key="index"
                    >
                        {{ item.CategoryName }}
                    </li>
                </ul>
            </div>

            <div class="product-right">

                <el-empty :image-size="200" v-if="!goodsList"></el-empty>

                <div class="goods-list">
                    <div class="pro-item hvr-float-shadow" v-for="(item,index) in goodsList" :key="index">
                        <img :src="$AttachmentDomainName+item.ThumbImagePath"/>
                        <p class="goods-info">
                            {{ item.GoodsAliasName }}
                        </p>
                        <div class="understand" @click="jumpGoodDetai(item.GoodsID)">
                            进一步了解 <img src="@/assets/img/more.png" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="news clearfix md-news">
            <div class="news-left clearfix">
                <h1 >新闻资讯</h1>
                <h2>永不分梨动态</h2>
                <ul>
                    <li :class="acitveNews === item.id ? 'active' : ''" v-for="(item, index) in list" :key="index"
                        @click="getList(item.id)">{{ item.name }}
                    </li>
                </ul>
            </div>

            <div class="news-right">

                <el-empty :image-size="200" v-if="!newList.length"></el-empty>

                <div class="news-list">
                    <div class="news-item boling-img" v-for="(item, index) in newList" :key="index">
                        <img :src="item.ThumbImagePath" alt=""/>
                        <h4>{{ item.Title }}</h4>
                        <p class="news-time">{{ item.PublishTime }}</p>
                        <p class="new-text">
                            {{ item.Summary }}
                        </p>
                        <div class="understand hvr-forward" @click="goDetail(item)">
                            进一步了解 <img src="@/assets/img/more.png" alt=""/>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {websiteApi} from "@/api/api";
import Swiper from "swiper"

export default {
    data() {
        return {
            goodsTitList: [],
            goodTitSelectIndex: 0,
            goodsList: [],
            newList: [],
            acitveNews: '2',
            list: [],
            newLoading: true,
            bannerList: [],
            bannerLoading: false,
            mySwiper: null
        };
    },
    head: {
        // Meta tags
        // meta: [
        //     { name: 'keywords', content: '17PR，公共关系，公关，品牌，营销，危机公关，品牌危机管理，品牌营销培训，品牌公关培训，品牌沙龙，品牌峰会' },
        //     { name: 'description', content: '17PR，最懂品牌公关营销的圈层媒体。2004年3月创立，持续关注品牌公关营销领域最新动态，为国内外品牌企业、专业代理机构及其从业人员，提供前沿深入的品牌公关营销资讯、热点事件解读、营销案例分析、行业年会、调查评选、传播培训、求职招聘、国际交流等专业服务。' }, // id to replace intead of create element
        // ],
    },
    async mounted() {
        this.getGoodCogyList();
        await this.getTabs()
        await this.getList(this.acitveNews)
        await this.getBanner()
        this.mySwiper = new Swiper('#home-swiper', {
            autoplay: 1500,//可选选项，自动滑动
            pagination: '.swiper-pagination',
            paginationClickable: true,
            effect: 'fade',
            loop: true
        })

        const that = this
        this.mySwiper.on('click', function ({activeIndex}){
            const PageName = that.bannerList[activeIndex - 1].PageName
            const LinkParameter = that.bannerList[activeIndex - 1].LinkParameter
            const url = window.location.protocol+"//"+window.location.host
            if(PageName == 'ExternalLink'){
                window.open(LinkParameter)
            }
            if(PageName == 'ArticleDetail'){
                window.open(url+'/detail?ArticleID=' + LinkParameter)
            }

            if(PageName == 'GoodsDetail'){
                window.open(url+'/productdetail?GoodID=' + LinkParameter)
            }
        })
    },
    methods: {
        getGoodCogyList() {
            let that = this;
            let params = {
                Action: "guanying.showcategory.list.get",
                DeviceType: that.$deviceType,
            };

            websiteApi.getGoods(params).then((res) => {
                if (res.Status == "Success") {
                    that.goodsTitList = res.Data;
                    let id = res.Data[0].ShowCategoryID;
                    that.changeGoods(id, 0);
                }
            });
        },
        //切换商品
        changeGoods(id, index) {
            let that = this;
            that.goodTitSelectIndex = index;
            let params = {
                Action: "guanying.showcategory.goods.get",
                DeviceType: that.$deviceType,
                PageID: 1,
                PageSize: 3,
                ShowCategoryID: id
            };

            websiteApi.getGoods(params).then((res) => {
                if (res.Status == "Success") {
                    that.goodsList = res.Data.GoodsList
                }
            });
        },
        //跳转商品详情
        jumpGoodDetai(id) {
            const url = window.location.protocol+"//"+window.location.host
            window.open(url + '/productdetail?GoodID=' + id)
        },
        goDetail(item){
            const url = window.location.protocol+"//"+window.location.host
            window.open(url + '/detail?ArticleID=' + item.ArticleID)
        },
        goPage(page){
            const url = window.location.protocol+"//"+window.location.host
            window.open(url + page)
        },
        async getTabs() {
            const res = await websiteApi.getArticle({
                Action: 'guanying.articlecategory.list.get',
                ParentCategoryID: 1,
                DeviceType: this.$deviceType
            })

            for (let key in res.Data) {
                this.list.push({
                    name: res.Data[key],
                    id: key
                })

            }
        },
        // 获取new
        async getList(id) {
            this.newLoading = true
            this.acitveNews = id
            const res = await websiteApi.getArticle({
                Action: 'guanying.article.list.get',
                PageID: 1,
                PageSize: 3,
                CategoryID: id,
                DeviceType: this.$deviceType
            })

            this.newList = res.Data.List
            this.newLoading = false

        },
        // 获取banner
        async getBanner() {
            this.bannerLoading = true
            const res = await websiteApi.getLoop({
                Action: 'guanying.web.bannerlist.get',
                DeviceType: this.$deviceType
            })

            this.bannerList = res.Data.BannerImageList
            this.bannerLoading = false


        }
    },
};
</script>
<style lang="scss" scoped>
@mixin title {
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303338;
}

@mixin small-title {
    font-size: 24px;
    font-family: SimHei;
    font-weight: 400;
    color: #9a9ea6;
    line-height: 70px;
    letter-spacing: 5px;
}

.understand {
    font-size: 18px;
    font-weight: 400;
    color: #df0615;
    line-height: 70px;
    cursor: pointer;

    > img {
        width: 9px;
        height: 16px;
        margin-left: 11px;
        line-height: 70px;
        vertical-align: unset;
    }
}

/*banner*/
.banner {
    width: 100%;
    height: 930px;
}


.swiper-container {
    --swiper-theme-color: #ff6600;
    --swiper-pagination-color: #00ff33; /* 两种都可以 */
}


.swiper-container {
    width: 100%;
    height: auto;

    .swiper-slide {
        cursor: pointer;
    }

    img {
        width: 100%;
        height: 100%;
    }
}



// 关于我们
.about {
    width: 100%;
    padding: 124px 160px 200px;
    background: #fff;

    .about-left {
        float: left;
        width: 55%;
        padding-right: 130px;

        h1 {
            @include title;
        }

        h2 {
            @include small-title;
        }

        .introduce {
            width: 100%;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 42px;
            text-align: justify;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
        }

        .price {
            margin-top: 60px;

            .price-item {
                margin-right: 60px;
                float: left;

                .price-title {
                    font-size: 30px;
                    font-weight: bold;
                    color: #303338;
                }

                .price-content {
                    font-size: 18px;
                    font-weight: 400;
                    color: #303338;
                    line-height: 30px;
                    text-align: justify;
                }
            }
        }
    }

    .about-right {
        float: left;
        width: 45%;
        height: 530px;

        > img {
            width: 100%;
            height: auto;
        }
    }
}

// 产品中心
.product {
    position: relative;
    width: 100%;
    padding: 155px 160px 90px;
    background: #f5f5f5;
    z-index: 10;

    .pro-bgk {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 539px;
        z-index: -1;

        > img {
            width: 100%;
            height: 100%;
        }
    }

    .product-left {
        float: left;
        width: 15%;

        .goodtitwrap {
            height: 460px;
            overflow-y: scroll;
        }

        > h1 {
            @include title;
        }

        > h2 {
            @include small-title;
        }

        > ul {
            margin-top: 20px;

            > li {
                font-size: 18px;
                font-family: SimHei;
                font-weight: 400;
                color: #303338;
                margin: 36px 0;
                cursor: pointer;
            }

            .active {
                color: #df0615;
            }
        }
    }

    .product-right {
        float: left;
        width: 85%;

        .goods-list {
            display: flex;

            .pro-item {
                float: left;
                width: 30%;
                height: 549px;
                background: #ffffff;
                text-align: center;
                margin-left: 77px;

                &:hover {
                    box-shadow: 0 0 0.104rem 0 rgb(0 0 0 / 10%);
                }

                //&:nth-child(1){
                //    margin-left: 0;
                //}
                > img {
                    width: 295px;
                    height: 295px;
                    margin-top: 33px;
                }

                .goods-info {
                    width: 286px;
                    font-size: 18px;
                    font-family: SimHei;
                    font-weight: 400;
                    color: #333333;
                    line-height: 36px;
                    margin: 30px auto 56px;
                    text-align: center;
                }

                .understand {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    font-weight: 400;
                    color: #df0615;
                    cursor: pointer;

                    > img {
                        width: 9px;
                        height: 16px;
                        margin-left: 11px;
                        vertical-align: unset;
                    }
                }
            }
        }
    }
}

// 新闻资讯
.news {
    width: 100%;
    padding: 124px 160px 200px;

    .news-left {
        float: left;
        width: 15%;

        > h1 {
            @include title;
        }

        > h2 {
            @include small-title;
        }

        > ul {
            margin-top: 60px;

            > li {
                font-size: 18px;
                font-family: SimHei;
                font-weight: 400;
                color: #303338;
                margin: 36px 0;
                cursor: pointer;
            }

            .active {
                color: #df0615;
            }
        }
    }

    .news-right {
        float: left;
        width: 85%;

        .news-list {
            display: flex;

            .news-item {
                float: left;
                width: 365px;
                margin-left: 75px;
                cursor: pointer;
                overflow: hidden;

                > h4 {
                    font-size: 24px;
                    font-family: SimHei;
                    font-weight: bold;
                    color: #333333;
                    line-height: 36px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin: 20px 0;
                }

                > img {
                    width: 100%;
                    height: 221px;
                }

                .news-time,
                .new-text {
                    font-size: 18px;
                    font-family: SimHei;
                    color: #888888;
                    line-height: 30px;
                    text-align: justify;
                    height: 54px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                .new-text {
                    margin-top: 10px;
                }
            }
        }
    }
}
@media screen and (max-width: 960px) {
    .md-about{
        width: 100%;
        padding: 40px 20px;
        background: #fff;
        .md-about-left{
            float: left;
            width: 100%;
            padding-right: 0px;
            > h1 {
                font-size: 30px;
                text-align: center;
            }
            > h2{
                font-size: 16px;
                margin-top: 12px;
                margin-bottom: 30px;
                text-align: center;
            }
            > .md-introduce{
                font-size: 18px;
                line-height: 42px;
                text-align: justify;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
            }
            .md-price-item{
                margin-right: 0;
                float: left;
                width: 100%;
                margin-bottom: 20px;
            }
            .price-title{
                font-size: 20px !important;
            }
            .price-content{
                font-size: 16px !important;
                line-height: 30px !important;

            }
        }
        .md-understand{
            font-size: 18px !important;
            margin-bottom: 20px;
            >img{
                width: 9px;
                height: 16px;
            }
        }
        .about-right{
            width: 100%;
            height: auto;
            > img{
                height: auto;
            }
        }
    }

    .md-pro{
            position: relative;
            width: 100%;
            padding: 40px 20px;
            background: #f5f5f5;
            z-index: 10;

            .pro-bgk {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                z-index: -1;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }

            .product-left {
                float: left;
                width: 100%;

                .goodtitwrap {
                    height: auto;
                    white-space: nowrap;
                    overflow-x: scroll;
                    overflow-y: scroll;
                    margin-bottom: 30px;
                }

                > h1 {
                    font-size: 30px;
                    text-align: center;
                }

                > h2 {
                    font-size: 16px;
                    margin-top: 12px;
                    margin-bottom: 30px;
                    text-align: center;
                }

                > ul {
                    margin-top: 0px;
                    text-align: center;
                    > li {
                        display: inline-block;
                        font-size: 18px;
                        font-family: SimHei;
                        font-weight: 400;
                        color: #303338;
                        margin: 10px 20px;
                        cursor: pointer;
                    }

                    .active {
                        color: #df0615;
                    }
                }
            }

            .product-right {
                float: left;
                width: 100%;

                .goods-list {
                    display: flex;
                    flex-wrap: nowrap;
                    overflow-x: scroll;

                    .pro-item {
                        float: left;
                        width: 100%;
                        height: auto;
                        background: #ffffff;
                        text-align: center;
                        margin-left: 0;
                        margin-right: 30px;
                        padding-bottom: 30px;
                        &:hover {
                            //box-shadow: 0 0 0.104rem 0 rgb(0 0 0 / 10%);
                        }

                        //&:nth-child(1){
                        //    margin-left: 0;
                        //}
                        > img {
                            width: 200px;
                            height: 200px;
                            margin-top: 0px;
                        }

                        .goods-info {
                            width: auto;
                            font-size: 16px;
                            font-family: SimHei;
                            font-weight: 400;
                            color: #333333;
                            line-height: 36px;
                            margin: 20px auto 10px;
                            text-align: center;
                        }

                        .understand {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 16px;
                            font-weight: 400;
                            color: #df0615;
                            cursor: pointer;

                            > img {
                                width: 9px;
                                height: 16px;
                                margin-left: 11px;
                                vertical-align: unset;
                            }
                        }
                    }
                }
            }
        }

    .md-news {
        width: 100%;
        padding: 40px 20px;

        .news-left {
            float: left;
            width: 100%;

            > h1 {
                font-size: 30px;
                text-align: center;
            }
            > h2{
                font-size: 16px;
                margin-top: 12px;
                margin-bottom: 30px;
                text-align: center;
            }

            > ul {
                margin-top: 0px;
                white-space: nowrap;
                overflow-x: scroll;
                text-align: center;
                margin-bottom: 30px;
                > li {
                    display: inline-block;
                    font-size: 18px;
                    font-family: SimHei;
                    font-weight: 400;
                    color: #303338;
                    margin: 10px 20px;
                    cursor: pointer;
                }

                .active {
                    color: #df0615;
                }
            }
        }

        .news-right {
            float: left;
            width: 100%;

            .news-list {
                display: flex;
                flex-wrap: nowrap;
                overflow-x: scroll;
                .news-item {
                    float: left;
                    width: 100%;
                    height: auto;
                    margin-left: 0;
                    margin-right: 50px;
                    cursor: pointer;
                    overflow: unset;
                    padding-bottom: 30px;

                    > h4 {
                        font-size: 24px;
                        font-family: SimHei;
                        font-weight: bold;
                        color: #333333;
                        line-height: 36px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin: 20px 0;
                    }

                    > img {
                        width: auto;
                        height: 200px;
                        margin: 0 auto;
                        display: block;
                    }

                    .news-time,
                    .new-text {
                        font-size: 18px;
                        font-family: SimHei;
                        color: #888888;
                        line-height: 30px;
                        text-align: justify;
                        height: 54px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }

                    .new-text {
                        margin-top: 10px;
                    }
                    .understand {
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        font-weight: 400;
                        color: #df0615;
                        cursor: pointer;
                        margin-top: 20px;
                        > img {
                            width: 9px;
                            height: 16px;
                            margin-left: 11px;
                            vertical-align: unset;
                        }
                    }
                }
            }
        }
    }

}
</style>

